import { CURRENT_USER } from "constants/storageKeys";

type PendingSignupFlags = {
  user_type?: string | null;
  type?: string | null;
  is_any_service_user?: boolean;
  is_service_user?: boolean;
  is_foreign_ca?: boolean;
  is_public_user?: boolean;
};

const USER_TYPE_KEY = "user_type";

export const readPendingSignupFlags = (): PendingSignupFlags => {
  try {
    const stored = localStorage.getItem(CURRENT_USER);
    const user = stored ? JSON.parse(stored) : {};

    return {
      ...user,
      user_type: user?.user_type || localStorage.getItem(USER_TYPE_KEY) || null,
    };
  } catch {
    return {};
  }
};
